import { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    q: 'Onde fica o Buteco do Baiano?',
    a: 'O Buteco do Baiano fica na Rua 8 de Setembro, 1444, no bairro da Varjota, em Fortaleza - CE, 60175-210. É um dos bairros mais badalados da cidade, com fácil acesso e estacionamento nas redondezas.',
  },
  {
    q: 'O Buteco do Baiano tem WhatsApp?',
    a: 'Sim! Você pode entrar em contato conosco pelo WhatsApp para fazer reservas, tirar dúvidas ou solicitar delivery. O número é (85) 98720-3361.',
  },
  {
    q: 'O local tem música ao vivo?',
    a: 'Sim, o Buteco do Baiano tem música ao vivo regularmente. Temos shows com artistas locais que embalam as noites com o melhor da música brasileira, MPB e samba.',
  },
  {
    q: 'Tem Área Climatizada?',
    a: 'Sim, temos Área Climatizada para quem quer aproveitar o clima agradável da Varjota. Também contamos com espaço na cobertura, perfeito para uma experiência ainda mais especial.',
  },
  {
    q: 'Tem mesas na cobertura?',
    a: 'Sim, o Buteco do Baiano possui um espaço na cobertura com vista e clima perfeito para a noite. É ideal para grupos e celebrações especiais.',
  },
  {
    q: 'O Buteco do Baiano trabalha com delivery?',
    a: 'Sim, trabalhamos com delivery para a região da Varjota e arredores. Você pode fazer seu pedido pelo WhatsApp e receber os petiscos e drinks na comodidade da sua casa.',
  },
  {
    q: 'Qual é a faixa de preço?',
    a: 'A faixa de preço no Buteco do Baiano é acessível, variando entre R$ 40 e R$ 120 por pessoa, dependendo do que for consumir. Temos opções para todos os bolsos, desde petiscos até pratos completos.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="contato" className="py-16 md:py-24 bg-cream-100">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16 reveal">
            <span className="inline-block text-gold-500 text-xs font-semibold tracking-widest uppercase mb-3">
              TIRE SUAS DÚVIDAS
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-brown-900 mb-4">
              Perguntas Frequentes
            </h2>
          </div>

          {/* Accordion */}
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-white rounded-xl shadow-sm overflow-hidden reveal"
                style={{ transitionDelay: `${i * 0.05}s` }}
              >
                <button
                  onClick={() => toggle(i)}
                  className="w-full flex items-center justify-between px-5 py-4 md:px-6 md:py-5 text-left hover:bg-cream-50 transition-colors"
                  aria-expanded={openIndex === i}
                >
                  <span className="font-heading text-sm md:text-base font-semibold text-brown-900 pr-4">
                    {faq.q}
                  </span>
                  <ChevronDown
                    size={20}
                    className={`text-gold-500 flex-shrink-0 transition-transform duration-300 ${
                      openIndex === i ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 pb-5 md:px-6 md:pb-6">
                    <p className="text-brown-600 text-sm leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
